import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavItemComponent } from './nav-item.component';
import { AppRoutingModule } from 'src/app/app-routing.module';



@NgModule({
  declarations: [
    NavItemComponent
  ],
  imports: [
    CommonModule, 
    AppRoutingModule
  ],
  exports: [
    NavItemComponent
  ]
})
export class NavItemModule { }
